<template>
	<div ref="slide" v-parallax-fit="parallax" class="slide-crown" id="slidecrown-2">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/10_treeflowers.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/henry/5.srt',
				'es': '/themes/rise-theme/resources/assets/audio/henry/5_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 25500,
					end: 27000,
					fromStyle: { opacity: 0 },
					toStyle: { opacity: 1 },
					easing: 'linear'
				}
			]
		};
	},
	created() {
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/henry/5.mp3';
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/7.png',
					url: 'https://www.uniformlaws.org/committees/community-home?CommunityKey=50724584-e808-4255-bc5d-8ea4e588371d',
					link_title: {
						'en': "Partition of Heirs Property Act",
						'es': 'Ley de Partición de la Propiedad de los Herederos'
					},
				}
			],
			text: {
				'en': '"The Uniform Partition of Heirs Property Act (UPHPA) helps preserve family wealth passed to the next generation in the form of real property. Tenants-in-common are vulnerable because any individual tenant can force a partition. Too often, real estate speculators acquire a small share of heirs’ property in order to file a partition action and force a sale. Using this tactic, an investor can acquire the entire parcel for a price well below its fair market value and deplete a family’s inherited wealth in the process." ',
				'es': '"La Ley de Partición Uniforme de la Propiedad de los Herederos (UPHPA, por sus siglas en inglés) ayuda a preservar el patrimonio familiar que pasa a la siguiente generación en forma de bienes inmuebles. Los inquilinos en común son vulnerables porque cualquier inquilino individual puede forzar una partición. Con demasiada frecuencia, los especuladores inmobiliarios adquieren una pequeña parte de la propiedad de los herederos para presentar una acción de partición y forzar una venta. Usando esta táctica, un inversionista puede adquirir la parcela completa por un precio muy por debajo de su valor justo de mercado y agotar la riqueza heredada de una familia en el proceso".'
			}
		};
		const text = {
			'en': "There's more reason to be hopeful. More and more states are passing partition law reform that could prevent people like Ronald from having their homes taken right from under them.",
			'es': 'Hay más razones para tener esperanza. Cada vez más estados están aprobando la reforma de la ley de partición que podría evitar que a personas como Ronald les quiten sus casas.'
		};

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if ((mutation.target.style.opacity * 1).toFixed(1) == 0.1) {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					self.$evidence.value = JSON.stringify(evidence);
					self.$readMore.value = text;
				}
			});
		});

		this.mutationObserver.observe(document.querySelector('#slidecrown-2'), {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
}
</script>

<style class="scss" scoped>
.slide-crown {
	width: 750px;
	position: absolute;
	top: -24%;
	left: 5.5%;
	transform: rotate(-1.5deg);
	transition: all 0.1s linear;
	opacity: 0;
}

@media screen and (max-width: 1680px) {
	.slide-crown {
		width: 650px;
		position: absolute;
		top: -21%;
		left: 6.5%;
	}
}

@media screen and (max-width: 1440px) {
	.slide-crown {
		width: 600px;
		top: -24%;
		left: 4%;
	}
}

@media screen and (max-width: 1280px) {
	.slide-crown {
		width: 400px;
		top: -21%;
		left: 5%;
	}
}

@media screen and (max-width: 650px) {
	.slide-crown {
		width: 200px;
		top: -22%;
		left: 5%;
	}
}
</style>
